<template>
  <header class="header flex justify-between items-center px4">
    <h1 class="header-h1">{{ appName }}</h1>
    <div>
      <span>{{ appVersion }}</span>
      <span>{{ user.username }} @</span>
      <a class="header-a" :href="url" target="_blank">{{ url }}</a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'app-header',
  computed: {
    appName: {
      get () { return this.$store.getters['app/name'] }
    },
    appVersion: {
      get () { return this.$store.getters['app/version'] }
    },
    url: {
      get () { return this.$store.getters['wordpress/account/url'] }
    },
    username: {
      get () { return this.$store.getters['wordpress/account/username'] }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

.header {
  width: 100%;
  height: $app_header_height;
  color: #999;
  background-color: $--color-base-black;
  &-h1 {
    font-size: 1.2em;
    font-weight: normal;
  }
  &-a {
    font-size: .8em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app/AppHeader.vue